class LetterCountInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector("[data-letter-count-text]");
    this.counter = this.querySelector("[data-letter-count-counter]");
    this.message = this.querySelector("[data-letter-count-message]");
    this.requiredCount = parseInt(this.dataset.requiredCount, 10) || 0;

    this.input?.addEventListener("input", this.updateStatus.bind(this));
    this.updateStatus();
  }

  // Only the leading count digit is replaced (not the whole localized string), so this stays correct
  // regardless of locale - mirrors PersonalizerSteps.updateCharCounter() in assets/personalizer.js.
  updateStatus() {
    const length = this.input?.value.length || 0;

    if (this.counter) {
      this.counter.textContent = this.counter.textContent.replace(/^\d+/, length);
    }

    if (!this.message) {
      return;
    }

    const remaining = Math.max(this.requiredCount - length, 0);

    if (remaining === 0) {
      this.message.hidden = true;
      return;
    }

    this.message.hidden = false;
    const template = remaining === 1 ? this.message.dataset.messageOne : this.message.dataset.messageOther;
    this.message.textContent = template.replace(/^\d+/, remaining);
  }
}

if (!window.customElements.get("letter-count-input")) {
  window.customElements.define("letter-count-input", LetterCountInput);
}
